import { render, staticRenderFns } from "./ScodeExam.vue?vue&type=template&id=3e695835&scoped=true"
import script from "./ScodeExam.vue?vue&type=script&lang=js"
export * from "./ScodeExam.vue?vue&type=script&lang=js"
import style0 from "./ScodeExam.vue?vue&type=style&index=0&id=3e695835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e695835",
  null
  
)

export default component.exports